import { StoreListType } from "../interface"
import { UserMenu } from "./UserMenu"
import { Tooltip } from 'react-tooltip'
import GoogleTranslate from "../../../../googleTranslate";
import { isStoreKuwaitRegion } from "../../../../constants/utils";
import useSessionStorage from "../../../../hooks/useSessionStorage";

export const RightSide: React.FC<{ storeList: StoreListType }> = ({ storeList }) => {
    const [storeDetails] = useSessionStorage('store_details', {} as any);

    return (
        <>
            <div className='justify-content-end m-auto color-black fs-14 d-block fw-500'>
                <div className='d-flex justify-content-end'>
                    {storeDetails?.store_name || localStorage.getItem("store_name") || localStorage.getItem("username")}
                </div>
                {storeDetails?.store_location || localStorage.getItem("store_location") ? (
                    <div
                        style={{
                            textAlign: "end",
                            maxWidth: "200px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // limit to 2 lines
                            WebkitBoxOrient: "vertical"
                        }}
                    >
                        {storeDetails?.store_location || localStorage.getItem("store_location")}
                    </div>
                ) : (
                    ""
                )}
            </div>
            <UserMenu
                storeList={storeList}
            />
            <div className="d-flex justify-content-center align-items-center">
                {isStoreKuwaitRegion() && <GoogleTranslate />}
            </div>
        </>
    )
}